<route>
{
  "meta": {
    "permission": [
      "matrix.view_matrixtemplate"
    ]
  }
}
</route>

<template>
  <v-container fluid>
    <i-table
      app="matrix.matrixtemplate"
      api="matrix.template"
      :headers="headers"
      :opt="{ matrix_use: 'product' }"
      :otherBtn="checkPermissions.add"
      :title="$tc('matrix', 2)"
      @click:create="changeRoute({ pk: 'create' })"
      @click:edit="changeRoute"
    >
      <template v-slot:otherBtn="{ item }">
        <i-btn
          :title="$tc('clone', 1)"
          outlined
          classes="mx-1"
          icon="fa-clone"
          color="secondary"
          @click="clone(item.pk, 'product')"
        />
      </template>
    </i-table>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    headers() {
      return [
        {
          text: this.$t('name'),
          value: 'name'
        },
        {
          text:
            this.checkPermissions.add ||
            this.checkPermissions.delete ||
            this.checkPermissions.edit
              ? this.$t('action')
              : '',
          value:
            this.checkPermissions.add ||
            this.checkPermissions.delete ||
            this.checkPermissions.edit
              ? 'actions'
              : '',
          align: 'center',
          width: '160px'
        }
      ]
    },
    ...mapGetters({
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin'
    }),
    /**
     * Determina si el usuario tiene los permisos necesarios según la indicación
     *
     * @returns {Object} Objeto con los permisos del usuario.
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    checkPermissions() {
      return {
        add: this.getPermissions([`matrix.add_matrixtemplate`]) || this.isAdmin,
        delete:
          this.getPermissions([`matrix.delete_matrixtemplate`]) || this.isAdmin,
        edit:
          this.getPermissions([`matrix.change_matrixtemplate`]) || this.isAdmin
      }
    }
  },
  methods: {
    changeRoute(item) {
      this.$router.push({
        name: 'matrix-pk',
        params: { pk: this.codification({ code: item.pk }) }
      })
    },
    async clone(pk, use) {
      const response = await this.$api.matrix.template.show({
        pk: pk,
        opt: { params: { clone: use } }
      })
      this.changeRoute({ pk: response.data.pk })
    }
  }
}
</script>
